/**
 * @generated SignedSource<<aeb86cd590f76176b5501c8e2a6e21cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExitSlipLessonRoadmapsQuery$variables = Record<PropertyKey, never>;
export type ExitSlipLessonRoadmapsQuery$data = {
  readonly curriculumLessons: ReadonlyArray<{
    readonly id: string;
    readonly targetGroup: {
      readonly id: string;
    } | null | undefined;
  }>;
};
export type ExitSlipLessonRoadmapsQuery = {
  response: ExitSlipLessonRoadmapsQuery$data;
  variables: ExitSlipLessonRoadmapsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "hasExitSlip": true,
          "isActive": "ACTIVE"
        }
      }
    ],
    "concreteType": "CurriculumLessonNode",
    "kind": "LinkedField",
    "name": "curriculumLessons",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetGroupNode",
        "kind": "LinkedField",
        "name": "targetGroup",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": "curriculumLessons(filter:{\"hasExitSlip\":true,\"isActive\":\"ACTIVE\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipLessonRoadmapsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ExitSlipLessonRoadmapsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3a047e11d9737f54771265e37cfddb0e",
    "id": null,
    "metadata": {},
    "name": "ExitSlipLessonRoadmapsQuery",
    "operationKind": "query",
    "text": "query ExitSlipLessonRoadmapsQuery {\n  curriculumLessons(filter: {hasExitSlip: true, isActive: ACTIVE}) {\n    id\n    targetGroup {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39bce618674e4978e1b9469c3f077e4d";

export default node;
